import { render, staticRenderFns } from "./ZoneManagePage.vue?vue&type=template&id=0da63546&scoped=true"
import script from "./ZoneManagePage.vue?vue&type=script&lang=js"
export * from "./ZoneManagePage.vue?vue&type=script&lang=js"
import style0 from "./ZoneManagePage.vue?vue&type=style&index=0&id=0da63546&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da63546",
  null
  
)

export default component.exports